import React, { CSSProperties } from "react";
import { BlockIcon } from "./BlockIcon";
import { CircularProgress, Tooltip, Typography } from "@mui/material";
import { getBlockOption } from "modules/MainSurveyEditor/helpers/blocks";
import { ArrowIcon } from "shared/icons/ArrowIcon";
import { getClasses } from "shared/helpers/styleHelper";

export const DraggableBlockOption = (props: DraggableBlockOptionProps) => {
  const {
    blockType,
    title,
    nestedCount,
    handleExpand,
    isExpanded,
    isCursorOver,
    isNotDraggable,
    isSelected,
    isDraggedOverNested,
    isHidden,
    isLoading,
    isDragged,
    subtitle,
    isTitlePrimary,
    isMultiSelected,
    ...rest
  } = props;

  const isNameNotGiven = title === undefined || title === null;
  const blockOption = getBlockOption(blockType);
  const blockName = isNameNotGiven ? blockOption.name : title || "Untitled " + blockOption.name;
  const classes = getClasses({
    "module-draggable-block-option": true,
    "is-drag-over": !!isCursorOver,
    "is-drag-over-nested": !!isDraggedOverNested,
    "is-block-selected": !!isSelected,
    "is-hide": !!isHidden,
    "is-multi-selected": !!isMultiSelected,
    "is-dragged": !!isDragged,
  });

  return (
    <div
      className={classes}
      draggable={!isNotDraggable}
      style={{ ...rest.style, "--nested-count": nestedCount } as CSSProperties}
      {...rest}
    >
      {!!handleExpand && (
        <ArrowIcon
          sx={{ color: "var(--c-default-icon)", mr: "calc(var(--sm) * -1)" }}
          direction={isExpanded ? "down" : "right"}
          onClick={handleExpand ? () => handleExpand(!isExpanded) : undefined}
        />
      )}
      <BlockIcon blockType={blockType} />
      {isLoading && <CircularProgress size={20} />}
      <div>
        <Tooltip title={blockName} enterDelay={2000}>
          <Typography
            className="one-line-text"
            color={isNameNotGiven || isTitlePrimary ? "text.primary" : "text.secondary"}
          >
            {blockName}
          </Typography>
        </Tooltip>
        {subtitle && (
          <Tooltip title={subtitle} enterDelay={2000}>
            <Typography className="one-line-text" color="text.secondary" variant="body2">
              {subtitle}
            </Typography>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

interface DraggableBlockOptionProps extends React.HTMLAttributes<HTMLDivElement> {
  blockType: string;
  title?: string;
  nestedCount?: number;
  handleExpand?: (isExpand: boolean) => void;
  isExpanded?: boolean;
  isCursorOver?: boolean;
  isNotDraggable?: boolean;
  isSelected?: boolean;
  isDraggedOverNested?: boolean;
  isHidden?: boolean;
  isLoading?: boolean;
  isDragged?: boolean;
  subtitle?: string;
  isTitlePrimary?: boolean;
  isMultiSelected?: boolean;
}
